/* eslint-disable camelcase */
import { noop } from 'lodash/fp';

import browserUtil from '../../../../utils/browser';
import config from '../../../../config';

export const configureAndLoad = ({ onLoad = noop }) => {
  const doc = browserUtil.getDocument();
  const script = doc.createElement('script') as HTMLScriptElement;
  script.async = true;
  script.src = '//opensdk.s3-ap-southeast-2.amazonaws.com/opensdk-1.3.0.min.js';
  doc.body.appendChild(script);
  script.onload = onLoad;
};

const { apiToken, apiEndpoint, portalUrl } = config.get('open');

export const launchQuoteForm = ({
  // @ts-expect-error - Automatic, Please fix when editing this file
  productId,
  // @ts-expect-error - Automatic, Please fix when editing this file
  productSlug,
  prepopulatedData = {},
  // @ts-expect-error - Automatic, Please fix when editing this file
  redirect,
  // @ts-expect-error - Automatic, Please fix when editing this file
  redirectBack,
  inNewTab = true,
}) => {
  // Open have upgraded car to the new quote portal. Home is still on the legacy.
  // @ts-expect-error - Automatic, Please fix when editing this file
  browserUtil.getWindow().opensdk.load(apiToken, {
    apiEndpoint,
    portalUrl,
  });
  browserUtil
    .getWindow()
    // @ts-expect-error - Automatic, Please fix when editing this file
    .opensdk.quote.prepare(productId, '', prepopulatedData)
    // @ts-expect-error - Automatic, Please fix when editing this file
    .then(({ quote_ref }) => {
      // @ts-expect-error - Automatic, Please fix when editing this file
      browserUtil.getWindow().opensdk.quote.portal(productId, quote_ref, {
        // @ts-expect-error - Automatic, Please fix when editing this file
        mode: inNewTab ? browserUtil.getWindow().opensdk.NEW_TAB : browserUtil.getWindow().opensdk.CURRENT_TAB,
        redirect,
        redirectBack,
      });
    });
};
